import React, { useState } from 'react';

import { useRouter } from 'next/router';
import UseModal from 'hooks/use-modal';


import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { proPlanCards } from 'constants/plans.const.js';
import { isIndianCurrency } from 'utils/currencyUtils';

import ActionButton from '@core/components/actionbutton/ActionButton';
import Modal from '@core/components/Modal/Modal';
import SubscriptionPaymentWrapper from './payment/SubscriptionPaymentWrapper';
import SubscriptionPaymentStepperPro from './payment/subscriptionpaymentstepper/SubscriptionPaymentStepperPro';
import PlanPricePro from './plancard/PlanPricePro';
import PeriodSelector from './plancard/PeriodSelector';
import PlanFeatureList from './plancard/PlanFeatureList';
import UpiBadge from './plancard/UpiBadge';
import FreePlanModal from './freeplanmodal/FreePlanModal';
import TrustHighlights from './TrustHighlights';

import PlanTitleImage from 'assets/images/pages/plans/plan-title-bf.svg'
import { InfoCircle, TickCircle } from 'iconsax-react';

import classes from './OurPlansPro.module.scss';
import FinancialAid from '@core/components/financialaid/FinancialAid';




const OurPlansPro = ({ data, isLoggedIn, toast, period, setPeriod }) => {
    const router = useRouter();
    const [planType, setPlanType] = useState('plus');
    const { show, showModal, destroyModal } = UseModal(false);
    const selectPlanHandler = (planType) => {
        setPlanType(planType);
        if (isLoggedIn) {
            var productId = '1';
            if(planType === 'plus')
            {
                period === 'Annual' ? productId='1' : productId='2';
            }
            else
                period === 'Annual' ? productId='3' : productId='4';
            router.push(`/checkout?productId=${productId}`);
        }
        else
            router.push('/login?next=' + router.asPath);
    };
    return (
        <>
            <section className={`${classes['wrapper']}`}>
                <div className='container'>
                    <div className='row flex-column align-items-center justify-content-center'>
                        <h1>Choose the Right Plan for Your Pharma Career</h1>
                        <p>Whether you are starting your first course, preparing for your next job, or planning a career change, Pharmuni gives you the learning, tools, and support to move forward.</p>

                        <TrustHighlights />

                        {/* <div>
                            <PlanTitleImage />
                        </div> */}
                        <PeriodSelector period={period} setPeriod={setPeriod} data={data.yearly} />
                        {isIndianCurrency(data?.monthly?.currency) && <UpiBadge />}
                        
                    </div>
                    <div className="row mt-5 px-0 px-xl-5 d-flex flex-md-row flex-column-reverse justify-content-center">
                        <div className={`col-xl-4 col-lg-6 col-12 d-flex justify-content-center justify-content-lg-end ${classes['side-col']}`}>
                            <article className={`${classes['paln-card']} ${classes['free']}`}>
                                <div className={classes['plan-name']}>
                                    {proPlanCards.starter.name}
                                </div>
                                <div className={classes['plan-tagline']}>
                                    {proPlanCards.starter.tagline}
                                </div>
                                <div className={classes.price}>
                                    <sup className={classes.currency}>{data.monthly.currency.symbol}</sup>0
                                </div>
                                <div className={classes['price-note']}>
                                    {proPlanCards.starter.priceNote}
                                </div>
                                {isLoggedIn
                                    ? (
                                        <div className={classes['current-plan']}>
                                            {proPlanCards.starter.currentPlanLabel}
                                        </div>
                                    )
                                    : (
                                        <ActionButton kind='simple' className={classes['outline-btn']} onClick={() => router.push('/login?next=' + router.asPath)}>
                                            {proPlanCards.starter.cta}
                                        </ActionButton>
                                    )
                                }
                                <PlanFeatureList features={proPlanCards.starter.features} />
                                <div className={classes['card-footnote']}>
                                    {proPlanCards.starter.footnote}
                                </div>
                            </article>
                        </div>
                        <div className={`col-xl-4 col-lg-6 col-12 d-flex justify-content-center justify-content-lg-center my-4 my-lg-0`}>
                            <div className={`${classes['card-wrapper']} ${(period === 'Annual' && data.yearly.number_of_months_saved && data.yearly.number_of_months_saved !== 0) && classes['has-promo']} `}>
                                <div className={classes['year-promo']}>
                                    {(period === 'Annual' && data.yearly.number_of_months_saved && data.yearly.number_of_months_saved !== 0) && (
                                        <>
                                            {/* <span>Pay for {12 - data.yearly.number_of_months_saved} months, get 1 year </span> */}
                                            <div className={classes['pop-badge']}>Most Popular</div>
                                        </>
                                    )}
                                </div>
                                <article className={`${classes['paln-card']} ${classes['plus']}`}>
                                    <PlanPricePro period={period} data={data} tagline={proPlanCards.plus.tagline} />
                                    <ActionButton kind='secondary_main' onClick={() => selectPlanHandler('plus')}>
                                        {proPlanCards.plus.cta}
                                    </ActionButton>
                                    <PlanFeatureList features={proPlanCards.plus.features} />
                                </article>
                            </div>
                        </div>
                        <div className={`col-xl-4 col-lg-6 col-12 d-flex justify-content-center justify-content-lg-start ${classes['side-col']}`}>
                            <article className={`${classes['paln-card']} ${classes['pro']}`}>
                                <PlanPricePro period={period} data={data} isPro={true} tagline={proPlanCards.pro.tagline} />
                                <ActionButton kind='secondary_main_light' onClick={() => selectPlanHandler('pro')}>
                                    {proPlanCards.pro.cta}
                                </ActionButton>
                                <PlanFeatureList features={proPlanCards.pro.features} />
                            </article>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center align-items-center mt-2 gap-2">
                        <TickCircle size="24" color="#18BBA8" variant="twotone" />
                        <p className='m-0'>Cancel anytime. No hidden fees.</p>
                    </div>
                    {/* <div className='d-flex justify-content-center mt-4'>
                        <FinancialAid />
                    </div> */}
                </div>
            </section>
            <Modal
                type={MOBILE_SLIDE_UP}
                title=""
                show={show}
                closeHandler={destroyModal}
                isGoPermium={true}
                header={false}
                
            >
                <FreePlanModal closeHandler={destroyModal} />
                {/* <div className={classes['payment-modal']}>
                    <SubscriptionPaymentWrapper
                        closeHandler={destroyModal}
                        toast={toast}
                        period={period}
                        setPeriod={setPeriod}
                    />
                </div> */}
                {/* <SubscriptionPaymentStepperPro
                    closeHandler={destroyModal}
                    toast={toast}
                    period={period}
                    setPeriod={setPeriod}
                    planType={planType}
                    setPlanType={setPlanType}
                    isPro={true}
                /> */}
            </Modal>
        </>
    );
};

export default OurPlansPro;